import React from 'react';
import './css/index.scss';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import TableCell from '../../../../components/TableCell';
import TableRow from '../../../../components/TableRow';
import { getActionText, getPaymentTypeText, getStatusText } from '../../constants';

function PaymentItem({
  item, widths, index, itemsPassed,
}) {
  const navigate = useNavigate();

  const onPaymentClick = () => {
    navigate(`/payments/single-view?id=${item._id}`);
  };

  return (
    <TableRow key={item._id} onClick={onPaymentClick} style={{ cursor: 'pointer' }}>
      <TableCell width={widths[0]}>{itemsPassed + index + 1}</TableCell>
      <TableCell width={widths[1]}>{getActionText(item.action_to_pay_for)}</TableCell>
      <TableCell width={widths[2]}>
        {item.value} {item.currency?.toUpperCase() || 'USD'}
      </TableCell>
      <TableCell width={widths[3]}>{getPaymentTypeText(item.payment_type)}</TableCell>
      <TableCell width={widths[4]}>
        {item.user_id?.display_name || item.user_id?.email || item.device_id?.device_unique_id || '—'}
      </TableCell>
      <TableCell width={widths[5]}>
        {item.createdAt ? moment(item.createdAt).format('DD/MM/YYYY HH:mm:ss') : '—'}
      </TableCell>
      <TableCell width={widths[6]}>{getStatusText(item.status)}</TableCell>
      <TableCell width={widths[7]} />
    </TableRow>
  );
}

export default PaymentItem;
